
export class AttachmentScenario {
recursivelyDirectorySearch: boolean | null;
}

